/* import __COLOCATED_TEMPLATE__ from './bullet-list.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();